<!--分析中表的展示方式-->
<template xmlns="http://www.w3.org/1999/html">
  <div style="width: 100%;display: flex;flex-direction: column;">

    <el-card shadow="never" class="box-card" v-if="showModelIntro" style="margin-bottom: 0px">
      <div slot="header" style="display: flex; justify-content:space-between;cursor: pointer"
           @click="changeModelIntro">
        <span>模块介绍</span>
        <i class="el-icon-arrow-up" v-show="showMoYes" style="cursor: pointer;color: #1e6cb0"
           title="展开模块介绍">折叠</i>
        <i class="el-icon-arrow-down" v-show="!showMoYes" style="cursor: pointer;color: #1e6cb0"
           title="折叠模块介绍">展开</i>
      </div>
      <div style="white-space: pre-line;text-indent: 2em;padding: 10px" v-show="showModelDetail"
           v-html=" getModelIntro()">
      </div>
    </el-card>
    <div v-if="showTable">
      <el-card style="padding: 20px;margin-top: 40px" shadow="never">
        <!--        <p>{{ getIntro(path) }}</p>-->
        <!--        三级ok-->
        <div v-if="floorsXlsState">
          <!--          @tab-click="clickFir"-->
          <!--          第一级大于6-->
          <el-tabs v-if="resultXlsOut.length>6" v-model="resultXlsOutName">
            <el-tab-pane :name="resultXlsOutName">
              <template v-slot:label>
                <el-select v-model="resultXlsOutName" filterable placeholder="请选择"
                           @change="handleSelectedTag">
                  <el-option
                    v-for="(elemF, index) in resultXlsOut"
                    :key="index"
                    :label="elemF.tagName"
                    :value="elemF.tagName">
                  </el-option>
                </el-select>
              </template>
              <!--              第一级大于6，第二级大于6-->
              <el-tabs v-if="selectedTag.sonTag.length>6">
                <el-tab-pane>
                  <template v-slot:label>
                    <el-select v-model="resultXlsInName" filterable placeholder="请选择"
                               @change="handleSelectedTagSec">
                      <el-option
                        v-for="(inElemSec,inIndexSec) in selectedTag.sonTag"
                        :key="inIndexSec"
                        :label="inElemSec.tagName"
                        :value="inElemSec.tagName">
                      </el-option>
                    </el-select>
                  </template>
                  <TaskDetailTabInner :tab-name="resultXlsInFileName" :tabList="selectedTagSec.sonTag"
                                      :show-tag="selectedTagSec.sonTag.length>6"
                                      :projectId="projectId" :groupSampleName="groupSampleName"
                                      :analyzeId="analyzeId" :path="path"
                                      @getTableLoading="getTableLoading"
                  >

                  </TaskDetailTabInner>
                </el-tab-pane>
              </el-tabs>
              <!--              第一级大于6，第二级小于6-->
              <el-tabs v-else v-model="resultXlsInName" @tab-click="clickSec">
                <!--                @tab-click="clickSec"-->
                <el-tab-pane
                  v-for="(inElemS,inIndex) in selectedTag.sonTag"
                  :key="inIndex"
                  :label="inElemS.tagName"
                  :name="inElemS.tagName"
                >
                  <TaskDetailTabInner :tab-name="resultXlsInFileName" :tabList="inElemS.sonTag"
                                      :show-tag="inElemS.sonTag.length>6"
                                      :projectId="projectId" :groupSampleName="groupSampleName"
                                      :analyzeId="analyzeId" :path="path" @getTableLoading="getTableLoading"
                  ></TaskDetailTabInner>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
          <!--          第一级小于6-->
          <el-tabs v-else v-model="resultXlsOutName" @tab-click="clickFir">
            <el-tab-pane
              v-for="(elemF, index) in resultXlsOut"
              :key="index"
              :label="elemF.tagName"
              :name="elemF.tagName">
              <!--              第一级小于，第二级大于-->
              <el-tabs v-model="resultXlsInName" v-if="elemF.sonTag.length>6">
                <!--               {{`${index}${selectedTagIndex}`}}-->
                <el-tab-pane :name="resultXlsInName" :key="Math.random().toString(36).substring(2, 9)">
                  <template v-slot:label>
                    <el-select v-model="resultXlsInName" filterable placeholder="请选择"
                               @change="handleSelectedTagSec">
                      <el-option
                        v-for="(inElemSec,inIndexSec) in elemF.sonTag"
                        :key="inIndexSec"
                        :label="inElemSec.tagName"
                        :value="inElemSec.tagName">
                      </el-option>
                    </el-select>
                  </template>
                  <TaskDetailTabInner :tab-name="resultXlsInFileName" :tabList="selectedTagSec.sonTag"
                                      :show-tag="selectedTagSec.sonTag.length>6"
                                      :projectId="projectId" :groupSampleName="groupSampleName"
                                      :analyzeId="analyzeId" :path="path" @getTableLoading="getTableLoading">
                  </TaskDetailTabInner>
                </el-tab-pane>
              </el-tabs>
              <!--              第一级小于6，第二级小于6-->
              <el-tabs v-model="resultXlsInName" v-else @tab-click="clickSec">
                <el-tab-pane
                  v-for="(inElemS,inIndex) in elemF.sonTag"
                  :key="inIndex"
                  :label="inElemS.tagName"
                  :name="inElemS.tagName"
                >
                  <TaskDetailTabInner :tab-name="resultXlsInFileName" :tabList="inElemS.sonTag" :projectId="projectId"
                                      :show-tag="inElemS.sonTag.length>6" :groupSampleName="groupSampleName"
                                      :analyzeId="analyzeId" :path="path" @getTableLoading="getTableLoading">
                  </TaskDetailTabInner>
                </el-tab-pane>
              </el-tabs>
            </el-tab-pane>
          </el-tabs>
        </div>

        <!--          二级OK-->
        <div v-if="floorXlsState">
          <el-tabs v-if="resultXlsOut.length>6" v-model="resultXlsOutName">
            <el-tab-pane :name="resultXlsOutName">
              <template v-slot:label>
                <el-select v-model="resultXlsOutName" filterable placeholder="请选择"
                           @change="handleSelectedTag">
                  <el-option
                    v-for="(elemF, index) in resultXlsOut"
                    :key="index"
                    :label="elemF.tagName"
                    :value="elemF.tagName">
                  </el-option>
                </el-select>
              </template>
              <TaskDetailTabInner :tab-name="resultXlsInName" :tabList="selectedTag.sonTag"
                                  :show-tag="selectedTag.sonTag.length>6"
                                  :key="Math.random().toString(36).substring(2, 9)"
                                  :projectId="projectId" :groupSampleName="groupSampleName"
                                  :analyzeId="analyzeId" :path="path" @getTableLoading="getTableLoading">
              </TaskDetailTabInner>
            </el-tab-pane>
          </el-tabs>
          <el-tabs v-else v-model="resultXlsOutName" @tab-click="clickFir">
            <el-tab-pane
              v-for="(elem, index) in resultXlsOut"
              :key="index"
              :label="elem.tagName"
              :name="elem.tagName">
              <TaskDetailTabInner :tab-name="resultXlsInName" :tabList="elem.sonTag" :show-tag="elem.sonTag.length>6"
                                  :projectId="projectId" :groupSampleName="groupSampleName"
                                  :analyzeId="analyzeId" :path="path" @getTableLoading="getTableLoading">
              </TaskDetailTabInner>
            </el-tab-pane>
          </el-tabs>
        </div>
        <TaskDetailTabInner :tab-name="resultXlsOutName" :tabList="resultXlsOut" :show-tag="resultXlsOut.length>6"
                            v-if="moreXlsState"
                            :projectId="projectId" :groupSampleName="groupSampleName"
                            :analyzeId="analyzeId" :path="path" @getTableLoading="getTableLoading">
        </TaskDetailTabInner>

        <!--        一个文件-->
        <div v-if="resultXlsOne">
          <p class="fileName">{{ resultXlsName }}分析结果文件</p>
          <table-detail :projectId="projectId" :analyzeId="analyzeId" :path="path"
                        :folder="oneXlsFolder" :fileName="resultXlsName" :passGroupSampleName="groupSampleName"
                        key="tableDetail" @getTableLoading="getTableLoading"
          ></table-detail>
        </div>
      </el-card>
    </div>

    <!--          //其他文件平铺-->
    <div v-if="resultOtherState" style="margin-top: 40px">
      <el-card shadow="never" style="padding: 20px">
        <div v-for="(item,index) in resultOther"
             :key="index">
          <div v-for="(inItem,inIndex) in item.fileList">
<!--            {{inItem.folder}}-->
            <li class="fileName">
              {{ normalizeShowFileName(inIndex + 1, inItem.filename) }}
              <el-button size="small" @click="downOtherFile(inItem.folder,inItem.filename)" style="margin-left: 30px">
                下载文件
              </el-button>
            </li>
            <p class="fileInformation">{{ getIntro(inItem.filename, inItem.folder) }}</p>
            <el-divider></el-divider>
          </div>
        </div>
      </el-card>
    </div>
    <task-log :showTaskLog="log.showTaskLog" :logContent="log.logContent"></task-log>
    <el-dialog
      title="提示"
      :visible.sync="dialogVisible"
      width="30%">
      <span>这是一段信息</span>
      <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span>
    </el-dialog>

  </div>

</template>


<script>
import {addZero, checkIsNumber, downloadBlob, fileDownload, normalizeShowFileName} from "@/utils/utils";
import TaskLog from '@/components/TaskLog'
import TableDetail from "@/components/TableDetail";
import {getModelIntro, introduce, note} from "@/utils/notes";
import {getFate} from "@/utils/wordConvert";
import Clickoutside from 'element-ui/src/utils/clickoutside'
import TaskDetailTabInner from "@/components/TaskDetailTabInner";
import {getDataInLocalStorage, saveDataToLocalStorage} from "@/utils/localStorageUtils";
import {getDataInSessionStorage} from "@/utils/sessionStorage";

const baseURL = process.env.VUE_APP_BASE_API
export default {
  props: {
    analyzeId: {
      type: String,
      default: ""
    },
    path: {
      type: String,
      default: ""
    },
    projectId: {
      type: String,
      default: ""
    }
  },
  directives: {Clickoutside},
 async created() {
    var path = getDataInSessionStorage('lastPath')
    if (path) {
      this.pathSplit = JSON.parse(JSON.stringify(path.lastIndexOf("/")))
      this.pathIndexFir = JSON.parse(JSON.stringify(path.substring(0, this.path.indexOf("."))))
      this.pathIndexSec = JSON.parse(JSON.stringify(path.substring(this.pathSplit + 1, this.pathSplit + 3)))
      if (!checkIsNumber(this.pathIndexSec, 'number')) {
        this.pathIndexSec = JSON.parse(JSON.stringify(path.substring(this.pathSplit + 1)))
      }
    }
    this.getResultFile()
    this.getShowModel()
    this.groupSampleName=await this.getAnalyzeGroupSampleNames()
  },
  components: {
    TaskDetailTabInner,
    'task-log': TaskLog,
    'table-detail': TableDetail
  },
  data() {
    return {

      log: {
        showTaskLog: false,
        logContent: ""
      },
      state: '',
      showTable: false,
      showDownloadModelResult: false,
      submitTime: '',
      analyzeData: '',
      fileNames: [],
      resultData: [],
      names: '',
      pathSplit: 0,
      pathIndexFir: 0,
      pathIndexSec: 0,
      resultSelect: '',
      resultName: '',
      resultState: false,
      showTaskInformation: false,
      folder: [],
      notice: '',
      dialogVisible: false,
      resultXlsName: '',
      resultXls: [],
      resultLists: [],
      resultXlsState: false,
      resultOther: [],
      resultOtherState: false,
      resultPdf: [],
      loading: true,
      resultXlsOne: false,
      showModelIntro: false,
      resultXlsSonNum: [0, 1],
      resultXlsOut: [],
      resultXlsOutName: '',
      resultXlsInName: '',
      resultXlsIn: [],
      resultXlsInFileName: '',
      floorXlsState: false,
      moreXlsState: false,
      oneXlsFolder: '',
      floorsXlsState: false,
      showInYes: true,
      showMoYes: true,
      showModelDetail: true,
      rightMenu: true,
      count: null,
      countSon: 0,
      selectedTag: [],
      selectedTagSec: {},
      selectedTagIndex: 0,
      selectedTagIndexSec: 0,
      groupSampleName:{}
    }
  },
  methods: {
    handleSelectedTag(value) {
      const index = this.getIndexSelectTag(value, this.resultXlsOut)
      this.selectedTag = this.resultXlsOut[index]
      this.selectedTagIndex = index
      this.resultXlsInName = this.resultXlsOut[index].sonTag[0].tagName//第一层选择完后，为了展示第二层，
      if (this.selectedTag.sonTag.length > 6) {
        this.selectedTagSec = this.selectedTag.sonTag[0]
      }
    },
    handleSelectedTagSec(value) {
      const index = this.getIndexSelectTag(value, this.selectedTag.sonTag)
      this.selectedTagSec = this.selectedTag.sonTag[index]
      this.selectedTagIndexSec = index
      this.resultXlsInFileName = this.selectedTag.sonTag[index].sonTag[0].tagName
    },
    getIndexSelectTag(value, obj) {
      const index = obj.findIndex(obj => obj.tagName === value)
      return index
    },
    getTableLoading() {
      this.countSon++
      if (this.count === this.countSon) {
        this.$store.commit('setTableLoading')
      }
    },
    normalizeShowFileName(third, name) {//规范名字的展示，01-01-01.xxx
      // pathIndexFir + '-' + pathIndexSec + '-' + addZero(index + 1) + (index + 1) + '.' + item.filename + '分析结果图'
      var finalName = normalizeShowFileName(this.pathIndexFir, this.pathIndexSec, third, name)
      if (finalName) {
        return finalName + '分析结果文件'
      } else return ""
    },
    clickFir(tab, event) {
      this.resultXlsInName = this.resultXlsOut[tab.index].sonTag[0].tagName
      if (this.resultXlsOut.length > 6) {
        this.selectedTag = this.resultXlsOut[tab.index]
      } else {
        // 第一层小于6
        this.selectedTagSec = this.resultXlsOut[tab.index].sonTag[0]
      }


    },
    clickSec(tab, event) {
      let length = this.resultXlsOut.length
      let out = this.resultXlsOut
      for (var i = 0; i < length; i++) {
        if (this.resultXlsOut[i].tagName === this.resultXlsOutName) {
          this.resultXlsInFileName = this.resultXlsOut[i].sonTag[tab.index].sonTag[0].tagName
        }
      }

    },
    controlTaskInformation() {
      this.showTaskInformation = !this.showTaskInformation
      this.showInYes = !this.showInYes
    },
    getShowModel() {
      let intro = this.getModelIntro(this.path)
      if (intro) {
        this.showModelIntro = true
      }
    },
    getModelIntro() {
      return getModelIntro(this.path)
    },
    changeModelIntro() {
      this.showModelDetail = !this.showModelDetail
      this.showMoYes = !this.showMoYes
    },
    async downloadModelResult() {
      if (!this.path) {
        const data = await this.$http({
          method: 'get',
          url: 'preview/downloadModelResult/' + this.projectId + '/' + this.analyzeId + "/" + this.path + "/" + this.resultName,
          responseType: 'blob',
        })
        if (data) {
          fileDownload(data)
          this.$messageUi.success('下载成功')
        } else {
          this.$messageUi('下载失败')
        }

      }
      // const url=`${baseURL}/preview/downloadModelResult/${this.projectId}/${this.analyzeId}/${this.path}/${this.resultName}?token=${getDataInLocalStorage("token")}`
      // const elink = document.createElement('a')
      // elink.href = url
      // document.body.appendChild(elink)
      // elink.click()
    },
    async showExecLog() {
      let res
      if (this.path === '') {
        res = await this.$http.get('analyze/log/' + this.analyzeId)
      } else {
        res = await this.$http.get('analyze/log/' + this.analyzeId + '/' + this.path + "/" + this.resultName)
      }
      if(res){
        if (res.code === 200) {
          this.log.showTaskLog = false
          this.log.showTaskLog = true
          this.log.logContent = res.data
        }
      }


    },
    async get() {
      for (let index in this.fileNames) {
        this.names += this.fileNames[index] + "\n"
      }
    },
    async downFile(index) {
      let sendData = {
        projectId: this.analyzeData.projectId,
        fileName: this.fileNames[index],
        analyzeId: this.analyzeId
      }
      this.projectId = this.analyzeData.projectId
      const fileName = this.fileNames[index]
      const analyzeId = this.analyzeId
      const data = await this.$http({
        method: 'get',
        url: '/analyze/downFiles/' + this.projectId + "/" + encodeURIComponent(fileName) + "/" + analyzeId,
        responseType: 'blob',
      })
      fileDownload(data.file, data.fileName)
    },
    // async viewFile(index) {
    //   const projectId = this.analyzeData.projectId
    //   const fileName = this.fileNames[index].toString()
    //   const analyzeId = this.analyzeId
    //   const res = await this.$http({
    //     method: 'get',
    //     url: '/analyze/downFiles/' + projectId + "/" + encodeURIComponent(fileName) + "/" + analyzeId,
    //     responseType: 'blob',
    //   })
    //   var indexOf = fileName.lastIndexOf(".")
    //   if (fileName.substring(indexOf + 1) === 'pdf') {
    //     var binaryData = [];
    //     binaryData.push(res.file);
    //     let url = window.URL.createObjectURL(
    //       new Blob(binaryData, {
    //         type: "application/pdf;charset=utf-8",
    //       })
    //     );
    //     if (url !== null && url !== undefined && url) {
    //       // vue路由跳转并以问号形式携带vue-pdf预览时所需要的pdf地址
    //       const {href} = this.$router.resolve({
    //         path: "/pdf",
    //         query: {
    //           url: url,
    //         },
    //       });
    //       // 新页面打开
    //       window.open(href, "_blank");
    //       this.openTheScanningdialog = false;
    //     }
    //   } else {
    //     const url = window.URL.createObjectURL(new Blob([res.file]))
    //     window.open(url, '_blank')
    //   }
    //
    // },
    async getResultFile() {
      if (this.path !== '') {
        this.showDownloadModelResult = true
        const res = await this.$http.get('/preview/dirFiles/' + this.projectId + "/" + this.analyzeId + "/" + this.path)
        // const res = getFate()
        if (res) {
          if (res.code === 200) {
            //   this.resultData = res.data
            let data = res.data
            data.forEach(elem => {
              let type = elem.typeName
              let length = elem.tags.length
              let tagsCon = elem.tags //tag具体内容
              if (type === 'table') {
                // let reLen = this.recurrenceGetLength(data[1].tags[0], 1)
                if (length >= 1) { //至少有一个tag或者只有一个xls
                  this.showTable = true
                  let sonTag
                  tagsCon.forEach(inElem => {
                    sonTag = inElem.sonTag
                  })//暂未考虑一个tag里有些有son有些没有
                  if (sonTag) {
                    let sonTagSec = sonTag[0].sonTag
                    //三级
                    if (sonTagSec) {
                      this.floorsXlsState = true
                      this.resultXlsOut = tagsCon
                      this.selectedTag = tagsCon[0]//有搜索框时的默认选择的sonTag
                      this.resultXlsOutName = tagsCon[0].tagName
                      this.selectedTagSec = tagsCon[0].sonTag[0]
                      this.resultXlsInName = tagsCon[0].sonTag[0].tagName
                      this.resultXlsInFileName = tagsCon[0].sonTag[0].sonTag[0].tagName
                      var count = 0
                      if (tagsCon.length > 6) {
                        if (tagsCon[0].sonTag.length > 6) {
                          if (tagsCon[0].sonTag[0].sonTag.length > 6) {//第三级大于6
                            count++
                          } else {
                            tagsCon[0].sonTag[0].sonTag.map(x => {
                              count++
                            })
                          }
                        } else {
                          tagsCon[0].sonTag.map(x => {
                            if (x.sonTag.length > 6) {
                              count++
                            } else {
                              x.sonTag.map(y => {
                                y.fileList.map(z => {
                                  count++
                                })
                              })
                            }
                          })
                        }
                      } else {
                        tagsCon.map(x => {
                          if (x.sonTag.length > 6) {//第二级大于6
                            if (x.sonTag[0].sonTag.length > 6) {//第三级大于6
                              count++
                            } else {
                              x.sonTag[0].sonTag.map(y => {
                                count++
                              })
                            }
                          } else {
                            x.sonTag.map(y => {
                              if (y.sonTag.length > 6) {//第三级大于6
                                count++
                              } else {
                                y.sonTag.map(z => {
                                  z.fileList.map(q => {
                                    count++
                                  })
                                })
                              }
                            })
                          }
                        })
                      }
                      this.count = count
                    } else {
                      // 二级
                      this.floorXlsState = true
                      this.resultXlsOut = tagsCon
                      this.resultXlsOutName = tagsCon[0].tagName
                      this.selectedTag = tagsCon[0]
                      this.resultXlsInName = tagsCon[0].sonTag[0].tagName
                      this.resultXlsInFileName = tagsCon[0].sonTag[0].fileList[0].filename
                      var count = 0
                      if (tagsCon.length > 6) {
                        if (tagsCon[0].sonTag.length > 6) {
                          count++
                        } else {
                          tagsCon[0].sonTag.map(x => {
                            x.fileList.map(y => {
                              count++
                            })
                          })
                        }
                      } else {
                        tagsCon.map(x => {
                          if (x.sonTag.length > 6) {//第二级
                            count++
                          } else {
                            x.sonTag.map(y => {
                              y.fileList.map(q => {
                                count++
                              })
                            })
                          }
                        })
                      }
                      this.count = count
                    }
                  } else {
                    // 一级
                    if (length === 1) {
                      // 只有一张表
                      this.resultXlsOne = true
                      this.oneXlsFolder = tagsCon[0].fileList[0].folder
                      this.resultXlsName = tagsCon[0].fileList[0].filename
                      this.count = 1
                    } else {
                      // 需要tag展示
                      this.moreXlsState = true
                      this.resultXlsOutName = tagsCon[0].tagName
                      this.resultXlsOut = tagsCon
                      if (tagsCon.length > 6) {
                        this.count = 1
                      } else {
                        this.count = tagsCon.length
                      }
                    }
                  }
                } else {
                  // 无xls
                  this.$store.commit('setTableLoading')
                }
              } else if (type === 'other') {
                if (length >= 1) {
                  let listLength = tagsCon[0].fileList.length
                  if (listLength > 0) {
                    this.resultOtherState = true
                    this.resultOther = tagsCon
                  }
                }

              } else {

              }
            })
          }
        }
      } else {
        this.showDownloadModelResult = false
      }
    },
    toAnalyzeTask() {
      // let routeData = this.$router.resolve({path: '/analyze', query: {analyzeId: analyzeId}});
      this.$router.push('/analyze?projectId=' + this.projectId)
    },
    handleMenu() {
      this.rightMenu = !this.rightMenu
      this.$store.commit('changeMenu')
    },
    resultList(resultName) {
      let index = 0
      this.$store.commit('setResultName', (this.resultName))
      saveDataToLocalStorage('resultNames', this.resultName)
      for (var elem in this.resultSelect) {
        let value = this.resultSelect[elem].name
        if (value === resultName) {
          index = elem
        }
      }
      let arr = JSON.stringify(this.resultData[index])
      if (arr) {
        return arr._2
      }
    },
    resultListNoPdf(resultName) {
      let index = 0
      this.$store.commit('setResultName', (this.resultName))
      saveDataToLocalStorage('resultNames', this.resultName)
      for (let elem in this.resultSelect) {
        let value = this.resultSelect[elem].name
        if (value === resultName) {
          index = elem
        }
      }
      if (this.resultData[index]) {
        let arr = JSON.parse(JSON.stringify(this.resultData[index]._2))
        let returnArr = []
        if (arr) {
          arr.forEach(function (item, key) {
            if (item.name.endsWith('pdf') || item.name.endsWith('png') || item.name.endsWith('jpg')) {
              // arr._2.splice(key, 1)
            } else {
              if (item.name.endsWith('tre') || item.name.endsWith('fasta')) {

              } else {
                returnArr.push(item)
              }
            }
          })
          if (returnArr.length !== 0) {
            this.showTable = true
            return returnArr
          }
        }
      }
    },

    downTable(folder) {
      this.dialogVisible = true
    },
    addZero(value) {
      return addZero(value)
    },
    getResultXlsFolder(resultXlsName) {
      if (resultXlsName) {
        let folder = ''
        let returnXLs = this.resultXls
        this.resultXls.forEach(function (item, index) {
          if (item.name === resultXlsName) {
            folder = returnXLs[index].folder
          }
        })
        return folder
      }
    },
    getIntro(fileName, folder) {
      return introduce(fileName, folder)
    },
    getNotice(folder) {
      return note(folder)
    },
    async downOtherFile(folder, name) {
      const data = await this.$http({
        method: 'get',
        url: '/preview/view/' + this.projectId + "/" + this.analyzeId + "/" + folder,
        responseType: 'blob',
      })
      fileDownload(data, name)
    },
    async getAnalyzeGroupSampleNames() {
      const res = await this.$http.get("/analyze/textContent/" + this.analyzeId).catch(error => {
        this.$messageUi.error("组名，样本名获取失败")
      })
      if (res) {
        if (res.code === 200) {
          var groupSampleName = {
            sampleName: res.data.sampleNames,
            groupName: res.data.groupNames
          }
          return groupSampleName
        } else {
          return ""
        }
      }
    },
  },
}
</script>

<style scoped>
.taskLabel {
  font-family: Microsoft YaHei !important;
  font-size: 15px !important;
  margin: 5px !important;
  color: #606266 !important;
  display: inline-block !important;
}

.look {
  font-family: "Microsoft YaHei";
  color: #606266;
  font-size: 16px;
  display: block;
  margin-bottom: 10px;

}

.look1 {
  font-family: "Microsoft YaHei";
  color: #606266;
  font-size: 16px;
}

.el-card /deep/ .el-card__header {
  padding: 10px 20px;
}

.el-card /deep/ .el-card__body {
  padding: 0px;
}

.box-card {
  margin: 20px 0px;
}

.fileName {
  /*list-style-type: disc;*/
  color: #1e6cb0;
  margin: 15px 0px;
}

.fileName:hover {
  /*border-bottom:1px solid #1e6cb0;*/
  /*text-decoration: underline;*/
}

.fileInformation {
  margin-bottom: 20px;
}

.row-bg {
  margin-bottom: 5px;
  color: #424242;
}
</style>
